const Actions = {
  CLEAR: 'app.actions.clear'
};

const Mutations = {
  CLEAR: 'app.mutations.clear'
};

export default {
  Actions,
  Mutations
};
